import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Field, Input } from '@itds/elements/index.js';

import Api from '@carrier/utils/Api';

const EditProductGroup = ({ productGroup, onClose, onDelete, onSave, show }) => {
  const [errors, setErrors] = useState([]);
  const [show_delete_warning, setDeleteWarning] = useState(false);
  const [data, setData] = useState({
    id: null,
    carrier_id: null,
    group_name: ''
  });

  useEffect(() => {
    const new_product_group = productGroup || {};

    setData({
      id: new_product_group.id,
      carrier_id: new_product_group.carrier_id,
      group_name: new_product_group.group_name || ''
    });
  }, [productGroup]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.group_name || data.group_name.length < 3) {
      errors.push('group_name');
    }

    setErrors(errors);

    if (!errors.length) {
      const { id, ...payload } = data;

      Api.saveProductGroup(id, payload).then(({ data }) => {
        onSave(data);
      });
    }
  };

  const handleDelete = () => {
    Api.deleteProductGroup(data.id).then(({ data }) => {
      onDelete(data);
      setDeleteWarning(null);
    });
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        show_delete_warning ? (
          <>
            <Button color='RED' onClick={handleDelete}>
              Confirm Deletion
            </Button>
            <Button
              onClick={setDeleteWarning.bind(null, false)}
              outline={true}
              style={{ marginLeft: 10 }}
            >
              Nevermind, I made a mistake
            </Button>
          </>
        ) : (
          <>
            <Button onClick={handleSave}>
              {data.id ? 'Save Changes' : 'Create Product Group'}
            </Button>
            {data.id ? (
              <Button
                color='RED'
                onClick={setDeleteWarning.bind(null, true)}
                outline={true}
                style={{ marginLeft: 10 }}
              >
                Delete
              </Button>
            ) : null}
          </>
        )
      }
      onClose={onClose}
      show={show}
      title={show_delete_warning ? 'Caution!' : `${data.id ? 'Edit' : 'New'} Product Group`}
    >
      {show_delete_warning ? (
        <div style={{ fontSize: 16, lineHeight: '1.6em', textAlign: 'center' }}>
          Deleting this product group will delete it's related products, quote data, and form data!
          This means, they will no longer be available to partners. Proceed with caution.
        </div>
      ) : (
        <Field label='Name'>
          <Input
            invalid={errors.includes('group_name')}
            onChange={handleInputChange.bind(null, 'group_name')}
            required={true}
            value={data.group_name}
          />
        </Field>
      )}
    </Drawer>
  );
};

EditProductGroup.propTypes = {
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  productGroup: PropTypes.object,
  show: PropTypes.bool
};

export default EditProductGroup;
